var map = {
	"./add.svg": 68,
	"./arrow_down.svg": 69,
	"./arrow_left.svg": 70,
	"./arrow_right.svg": 71,
	"./calendar_end.svg": 72,
	"./calendar_start.svg": 73,
	"./checkmark.svg": 74,
	"./edit.svg": 75,
	"./lock_closed.svg": 76,
	"./search.svg": 77,
	"./trash.svg": 78,
	"./users.svg": 79,
	"./x.svg": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;